import styled from 'styled-components';

export const Header = styled.h4`
  margin: 0 0 5px;
  font-size: 16px;
  color: ${({ theme }) => theme.colors.primaryText};
  display: flex;
  align-items: center;
`;

export const Description = styled.p`
  color: ${({ theme }) => theme.colors.gray};
  margin: 0;
`;

export const Icon = styled.div``;

export const HoverIcon = styled.div``;

export const Container = styled.a`
  display: flex;
  flex-flow: row;
  align-items: center;
  cursor: pointer;
  border: 1px solid rgba(0, 0, 0, 0.15);
  border-radius: 4px;
  padding: 20px;
  color: ${({ theme }) => theme.colors.bodyBgLight};
  transition: all 0.25s ease-in-out;
  margin-bottom: 20px;

  ${HoverIcon} {
    display: none;
  }
  ${Icon} {
    display: block;
    opacity: 0.4;
  }

  &:hover {
    transform: translateY(-1px);
    box-shadow: 0 5px 10px 0 rgb(0 0 0 / 12%);
    border-color: white;
    background: white;
    text-decoration: none;

    ${HoverIcon} {
      display: block;
    }
    ${Icon} {
      display: none;
    }

    ${Header}, ${Description} {
      color: ${({ theme }) => theme.colors.primary};
    }
  }
`;

export const IconContainer = styled.div`
  margin-right: 20px;
`;
